module.exports = __webpack_public_path__ + "static/whistle-debut.1fe332a9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whistle-debut.jpeg
// module id = 993
// module chunks = 263791100135453